var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.000000, -248.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44206379,4.0596147 L12.2609558,4.0596147 L12.2238991,2.54638672 C12.2238991,2.06476385 11.8323864,1.67325107 11.3507635,1.67325107 L6.11505682,1.67325107 L6.11505682,0.882457386 C6.11505682,0.400834517 5.72354403,0.00932173295 5.24192116,0.00932173295 L0.879350142,0.00932173295 C0.397727273,0.00932173295 0.00621448864,0.400834517 0.00621448864,0.882457386 L0.00621448864,11.1146129 L1.56892813,4.93119673 C1.56892813,4.45112749 1.96044092,4.0596147 2.44206379,4.0596147 Z",
    fill: "#1974CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3878202,12.1130593 L0.00621448864,12.1146129 L0.00466086648,4.31508849 C0.00466086648,3.83346563 0.393066406,3.44195284 0.876242898,3.44195284 L11.3878202,3.44195284 C11.869443,3.44195284 12.2594022,3.83346563 12.2594022,4.31508849 L12.2609558,11.2399237 C12.2609558,11.7231001 11.869443,12.1130593 11.3878202,12.1130593 Z",
    fill: "#1887F1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirActive);
export default __webpack_public_path__ + "static/media/dirActive.627c0494225e05a9856e3362fca0e315.svg";
export { ForwardRef as ReactComponent };